// Read-only "view as" (צפייה כ…) — client half. Mirrors server/lib/roles.js
// VIEW_AS_TARGETS (sync pair) and server/lib/viewAs.js.
//
// The previewed role lives in sessionStorage, NOT localStorage: it is per
// browser tab, so previewing in one tab never changes what the user's other
// tabs show (same reason the Command Center never touches restaurantId).
// Every read/write is guarded — storage can be unavailable (private mode,
// blocked site data), and then there is simply no preview.
export const VIEW_AS_STORAGE_KEY = 'viewAs';
export const VIEW_AS_HEADER = 'X-View-As';

export const VIEW_AS_TARGETS = Object.freeze({
  admin: Object.freeze(['hq_admin', 'manager', 'viewer']),
  hq_admin: Object.freeze(['manager']),
});

export const viewAsTargetsFor = (realRole) => VIEW_AS_TARGETS[realRole] || [];
export const canViewAs = (realRole, target) => viewAsTargetsFor(realRole).includes(target);

// Every role anyone may preview as. A stored value outside it (hand-edited,
// left by an older build) is dropped rather than sent as a header forever.
const PREVIEWABLE = new Set(Object.values(VIEW_AS_TARGETS).flat());

export function readViewAs() {
  try {
    const stored = window.sessionStorage.getItem(VIEW_AS_STORAGE_KEY);
    if (!stored) return null;
    if (PREVIEWABLE.has(stored)) return stored;
    window.sessionStorage.removeItem(VIEW_AS_STORAGE_KEY);
    return null;
  } catch { return null; }
}

export function writeViewAs(role) {
  try {
    if (role) window.sessionStorage.setItem(VIEW_AS_STORAGE_KEY, role);
    else window.sessionStorage.removeItem(VIEW_AS_STORAGE_KEY);
  } catch { /* storage unavailable: the preview simply does not persist */ }
}

// The Command Center is Peak's own console and is never previewed (the server
// ignores the header there too).
export const isPeakConsolePath = (pathname) =>
  pathname === '/command-center' || String(pathname || '').startsWith('/command-center/');
